import moment from "moment";
import { createColumnHelper } from "@tanstack/react-table";
import {
  ViewActionButton,
  EditActionButton,
  ListActionButton,
} from "../../../../components/common/primebmd-ui/EditActionButton";
import { IEUR } from "../utils/types";
import { usePermission } from "../../../../hooks/usePermissions";
import { Modules, Permissions } from "../../../Users/Roles/roles-utils";
import { Chip } from "@mui/material";

const columnHelper = createColumnHelper<Partial<IEUR>>();

const EURLogsColumns = () => {
  const hasEditPermission = usePermission(
    Modules.eur.accessKey,
    Permissions.edit
  );
  const EURLogsColumns = [
    columnHelper.accessor("eurNo", {
      id: "eurNo",
      header: "EUR No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
      enableHiding: true,
    }),
    columnHelper.accessor("date", {
      id: "date",
      header: "Date",
      cell: (row) => moment(row.getValue()).format("MM/DD/yyyy"),
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true,
    }),
    columnHelper.accessor("equipmentNo", {
      id: "equipmentNo",
      header: "Equipment No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true,
    }),
    columnHelper.accessor("operator", {
      id: "operator",
      header: "Operator",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true,
    }),
    columnHelper.accessor("location", {
      id: "location",
      header: "Location",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true,
    }),
    columnHelper.accessor(
      row => row.endingReading != null, // true = completed, false = started
      {
        id: "status",
        header: "Status",

        cell: ({ getValue }) => {
          const isCompleted = getValue();

          return (
            <Chip
              color={isCompleted ? "success" : "default"}
              label={isCompleted ? "Completed" : "Started"}
              size="small"
            />
          );
        },

        // Boolean sorting
        sortingFn: (rowA, rowB, columnId) => {
          const a = rowA.getValue(columnId) ? 1 : 0;
          const b = rowB.getValue(columnId) ? 1 : 0;
          return a - b;
        },
      }
    ),
    columnHelper.display({
      id: "actions",
      header: "Action",
      cell: ({ row }) => (
        <>
          <ViewActionButton route={`/eur/view/${row.original.id}`} />
          {hasEditPermission && <EditActionButton route={`/eur/edit/${row.original.id}`} />}
          {/*ListActionButton route={`/eur/${row.original.id}/activity`} /> */}
        </>
      ),
      enableHiding: false,
    }),
  ];
  return EURLogsColumns;
};

export default EURLogsColumns;
